import { HttpError } from '../../http/HttpError';
import { HttpMethod } from '../../http/HttpRequest';
import { combineURLs } from '../../utils/URL';
import { CURIEs } from './CURIEs';
/**
 * @hidden
 */
export class DefaultHalClient {
    constructor(baseUrl, httpClient, tokenProvider) {
        this.baseUrl = baseUrl;
        this.httpClient = httpClient;
        this.tokenProvider = tokenProvider;
    }
    async fetchLinkedResource(link, params, resourceConstructor) {
        let href = link.href;
        if (link.templated) {
            href = CURIEs.expand(href, params);
        }
        return this.fetchResource(href, resourceConstructor);
    }
    async fetchResource(path, resourceConstructor) {
        const response = await this.invoke({
            method: HttpMethod.GET,
            url: path,
        });
        return this.parse(response.data, resourceConstructor);
    }
    async createLinkedResource(link, params, resource, resourceConstructor) {
        let href = link.href;
        if (link.templated) {
            href = CURIEs.expand(href, params);
        }
        return this.createResource(href, resource, resourceConstructor);
    }
    async createResource(path, resource, resourceConstructor) {
        const response = await this.invoke({
            data: this.serialize(resource),
            method: HttpMethod.POST,
            url: path,
        });
        return this.parse(response.data, resourceConstructor);
    }
    async updateResource(path, resource, resourceConstructor) {
        const response = await this.invoke({
            data: this.serialize(resource),
            method: HttpMethod.PATCH,
            url: path,
        });
        return this.parse(response.data, resourceConstructor);
    }
    async updateLinkedResource(link, params, resource, resourceConstructor) {
        let href = link.href;
        if (link.templated) {
            href = CURIEs.expand(href, params);
        }
        return this.updateResource(href, resource, resourceConstructor);
    }
    async deleteLinkedResource(link, params) {
        let href = link.href;
        if (link.templated) {
            href = CURIEs.expand(href, params);
        }
        return this.deleteResource(href);
    }
    async deleteResource(path) {
        await this.invoke({
            method: HttpMethod.DELETE,
            url: path,
        });
        return Promise.resolve();
    }
    async performActionWithoutResourceResponse(link) {
        await this.invoke({
            method: HttpMethod.POST,
            url: link.href,
        });
        return Promise.resolve();
    }
    async performActionThatReturnsResource(link, params, data, resourceConstructor) {
        let href = link.href;
        if (link.templated) {
            href = CURIEs.expand(href, params);
        }
        const response = await this.invoke({
            data: this.serialize(data),
            method: HttpMethod.POST,
            url: href,
        });
        return this.parse(response.data, resourceConstructor);
    }
    parse(data, resourceConstructor) {
        const instance = new resourceConstructor(data);
        instance.setClient(this);
        return instance;
    }
    serialize(data) {
        return JSON.parse(JSON.stringify(data));
    }
    async invoke(request) {
        const token = await this.tokenProvider.getToken();
        const fullRequest = {
            data: request.data,
            headers: {
                Authorization: 'bearer ' + token.access_token,
            },
            method: request.method,
            url: combineURLs(this.baseUrl, request.url),
        };
        return this.httpClient.request(fullRequest).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                if (typeof response.data === 'string') {
                    response.data = JSON.parse(response.data);
                }
                return response;
            }
            else {
                throw new HttpError(`Request failed with status code ${response.status}: ${JSON.stringify(response.data)}`, fullRequest, response);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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